<template>
    <vue-element-loading
        :active="status"
        spinner="bar-fade-scale"
        size="60"
        :delay="0"
        :is-full-screen="fullPage"
        :text="comment"
        background-color="#FFFFFF"
        color="#4299E1"
    />
</template>

<script>
export default {
    name: "loading",
    props: {
        status: {
            type: Boolean,
            required: true,
            default: true
        },
        fullPage: {
            type: Boolean,
            default: false
        },
        comment: {
            type: String,
            default: ''
        },
    }
}
</script>
